module.exports = __webpack_public_path__ + "08ed896b0a48217ab3e1ab7aa7f9ceab.png";